import { jsx as l } from "react/jsx-runtime";
const v = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.165 5.232 1.51-.404c.541.965.825 2.048.825 3.172 0 3.584-2.916 6.5-6.5 6.5A6.508 6.508 0 0 1 1.5 8c0-3.391 2.61-6.184 5.928-6.475.284-.627.948-1.067 1.72-1.067H10.5v1.5H9.148c-.217 0-.368.131-.368.25 0 .117.151.25.368.25H10.5v1.5H9.148c-.716 0-1.337-.379-1.651-.933A5.007 5.007 0 0 0 3 8c0 2.757 2.243 5 5 5s5-2.243 5-5c0-.994-.289-1.947-.835-2.768Zm-1.094 1.59h1.101l-.402 1.5h-.52v2.151H9.625v-.829h-3.25v.829H4.75V8.322h-.547l-.402-1.5h1.113L5.562 5.5h4.803l.706 1.322ZM6.25 8.144h3.5v-.612L9.465 7H6.498l-.248.505v.639Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  v as ElectricCar
};
